export function IconSource(name: string, extension?: string): string {
  return `${process.env.PUBLIC_URL}/media/icons/${name}.${extension ?? 'svg'}`;
}

export function ImageSource(name: string, extension?: string): string {
  return `${process.env.PUBLIC_URL}/media/images/dummy/${name}.${extension ?? 'svg'}`;
}
